/*
 * Clinch IT — <clinch-swiper> custom element.
 * Wraps Swiper. Reads options from the data-swiper JSON attribute and
 * initializes the inner `.swiper`. Navigation/pagination elements are
 * resolved from inside the element so multiple sliders never collide.
 */
(function () {
  class ClinchSwiper extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      let cfg = {};
      try {
        cfg = JSON.parse(this.dataset.swiper || '{}');
      } catch (e) {
        cfg = {};
      }

      const opts = Object.assign({ slidesPerView: 1, spaceBetween: 16 }, cfg);

      if (cfg.navigation) {
        opts.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        };
      }
      if (cfg.pagination) {
        opts.pagination = {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        };
      }
      if (cfg.autoplay) {
        opts.autoplay = { delay: cfg.autoplayDelay || 6000, disableOnInteraction: false };
      }

      const container = this.querySelector('.swiper');
      if (!container) return;

      const start = () => {
        if (!window.Swiper) return;
        this.swiper = new window.Swiper(container, opts);
      };

      if (window.Swiper) {
        start();
      } else {
        // swiper-bundle is deferred; it will be ready by window load at the latest.
        window.addEventListener('load', start, { once: true });
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.initialized = false;
    }
  }

  if (!customElements.get('clinch-swiper')) {
    customElements.define('clinch-swiper', ClinchSwiper);
  }
})();
